/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Trackermodal_Signincta3Inputs */

const he_extension_trackermodal_signincta3 = /** @type {(inputs: Extension_Trackermodal_Signincta3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`להתחברות`)
};

const en_extension_trackermodal_signincta3 = /** @type {(inputs: Extension_Trackermodal_Signincta3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Extension_Trackermodal_Signincta3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_trackermodal_signincta3 = /** @type {((inputs?: Extension_Trackermodal_Signincta3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Trackermodal_Signincta3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_trackermodal_signincta3(inputs)
	return en_extension_trackermodal_signincta3(inputs)
});
export { extension_trackermodal_signincta3 as "extension_trackerModal_signInCta" }